"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("../helpers");
var StackView_1 = require("../StackView");
var Text_1 = require("../Text");
var Tab = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 6px ", ";\n    cursor: pointer;\n\n    ", "\n\n    ", "\n"], ["\n    padding: 6px ", ";\n    cursor: pointer;\n\n    ",
    "\n\n    ",
    "\n"])), helpers_1.SPACING_L, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        border-bottom: ", " solid\n            ", ";\n\n        &:hover {\n            background-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n        }\n    "], ["\n        color: ", ";\n        border-bottom: ", " solid\n            ", ";\n\n        &:hover {\n            background-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n        }\n    "])), isActive ? theme.colorTextTab : theme.colorTextTabNeighbor, isActive ? '4px' : '2px', isActive ? theme.colorStripeAccent : theme.colorBorderMain, isActive ? '#fff' : theme.colorHighlightLight, !isActive && theme.colorHighlightDark);
}, function (_a) {
    var isActive = _a.isActive;
    return isActive && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            cursor: default;\n            padding-top: 6px;\n            padding-bottom: 5px;\n        "], ["\n            cursor: default;\n            padding-top: 6px;\n            padding-bottom: 5px;\n        "])));
});
var StyledText = styled_components_1.default(Text_1.Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    text-decoration: none;\n"], ["\n    text-decoration: none;\n"])));
exports.TabBar = helpers_1.createUIElement('TabBar', function (_a, ref) {
    var className = _a.className, items = _a.items, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "items", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(StackView_1.StackView, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'tabbar-wrapper', className: "vm-TabBar " + className, direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.none, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), items.map(function (_a, idx) {
        var title = _a.title, active = _a.active, href = _a.href, onClick = _a.onClick;
        var WideTextProps = {};
        if (href) {
            WideTextProps.asTag = 'a';
            WideTextProps.href = href;
        }
        if (!active) {
            WideTextProps.onClick = onClick;
        }
        return (react_1.default.createElement(StyledText, __assign({ key: "TabBar-tab-" + idx, "data-selector-id": "tabbar-tab-" + (idx + 1), size: Text_1.TEXT_SIZE.l }, WideTextProps),
            react_1.default.createElement(Tab, { isActive: active }, title)));
    })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=TabBar.js.map